import { GetOperationalCAAMetricsPatientMonthCase } from './domain/useCases/getOperationalCAAMetricsPatientMonthCase'
import { GetOperationalCAAMetricsPatientSemesterCase } from './domain/useCases/getOperationalCAAMetricsPatientSemesterCase'
import { GetOperationalCAAMetricsPatientWeekCase } from './domain/useCases/getOperationalCAAMetricsPatientWeekCase'
import { GetOperationalCAAMetricsPatientYearCase } from './domain/useCases/getOperationalCAAMetricsPatientYearCase'
import { GetOperationalCAAMetricsTherapistMonthCase } from './domain/useCases/getOperationalCAAMetricsTherapistMonthCase'
import { GetOperationalCAAMetricsTherapistSemesterCase } from './domain/useCases/getOperationalCAAMetricsTherapistSemesterCase'
import { GetOperationalCAAMetricsTherapistWeekCase } from './domain/useCases/getOperationalCAAMetricsTherapistWeekCase'
import { GetOperationalCAAMetricsTherapistYearCase } from './domain/useCases/getOperationalCAAMetricsTherapistYearCase'
import { GetPatientCAAMetricsMonthCase } from './domain/useCases/getPatientCAAMetricsMonthCase'
import { GetPatientCAAMetricsSemesterCase } from './domain/useCases/getPatientCAAMetricsSemesterCase'
import { GetPatientCAAMetricsWeekCase } from './domain/useCases/getPatientCAAMetricsWeekCase'
import { GetPatientCAAMetricsYearCase } from './domain/useCases/getPatientCAAMetricsYearCase'
import { caaMetricsDatasourceAdapter } from './external/datasources/caaMetricsDatasourceAdapter'
import { caaMetricsRepositoryAdapter } from './infra/repositories/caaMetricsRepositoryAdapter'

const repository = caaMetricsRepositoryAdapter(caaMetricsDatasourceAdapter)

export const caaMetricsInstance = {
  getPatientCAAMetricsWeek: GetPatientCAAMetricsWeekCase(repository),
  getPatientCAAMetricsMonth: GetPatientCAAMetricsMonthCase(repository),
  getPatientCAAMetricsSemester: GetPatientCAAMetricsSemesterCase(repository),
  getPatientCAAMetricsYear: GetPatientCAAMetricsYearCase(repository),
  getOperationalCAAMetricsPatientWeek:
    GetOperationalCAAMetricsPatientWeekCase(repository),
  getOperationalCAAMetricsPatientMonth:
    GetOperationalCAAMetricsPatientMonthCase(repository),
  getOperationalCAAMetricsPatientSemester:
    GetOperationalCAAMetricsPatientSemesterCase(repository),
  getOperationalCAAMetricsPatientYear:
    GetOperationalCAAMetricsPatientYearCase(repository),
  getOperationalCAAMetricsTherapistWeek:
    GetOperationalCAAMetricsTherapistWeekCase(repository),
  getOperationalCAAMetricsTherapistMonth:
    GetOperationalCAAMetricsTherapistMonthCase(repository),
  getOperationalCAAMetricsTherapistSemester:
    GetOperationalCAAMetricsTherapistSemesterCase(repository),
  getOperationalCAAMetricsTherapistYear:
    GetOperationalCAAMetricsTherapistYearCase(repository)
}
